// import { assignmentTitleArray } from "./seletctOptions";
//
// const KNOWN_TITLE_KEYS = assignmentTitleArray
//   .filter((o) => o.key !== "Other")
//   .map((o) => o.key);

export const validationCreateAml = (aml) => {
  const { type, name, email, language, risk } = aml || {};

  const errors = [];
  if (!type) errors.push("type");

  if (type === "PG") {
    if (!name) errors.push("name");
  } else if (type === "PF") {
    if (!name) errors.push("name");
  }
  if (!email) errors.push("email");
  if (!language) errors.push("language");
  if (!risk) errors.push("risk");
  // if (!title) errors.push("title");
  // const isTitleOther = !!title && !KNOWN_TITLE_KEYS.includes(title);
  // if (isTitleOther && !reason) errors.push("reason");

  return errors;
};
